import globals from '@/utils/globals';
import { store } from '../store';

export class BestFitOpenerPlugin {
	private completed = false;
	private studyId?: number;

	public initiate(): void {
		const url = new URL(window.location.toString());
		const shouldOpenBestFit = url.searchParams.get('openbestfit');
		const isStudies = window.location.pathname.split('/')[1] === 'studies';
		this.studyId = parseInt(window.location.pathname.split('/')[2]);
		if (shouldOpenBestFit === 'true' && isStudies) {
			this.openBestFit();
		}
	}

	private openBestFit(): void {
		if (this.completed) {
			return;
		}

		// open questionnaire when not logged in or completeness < 100
		if (!store.getters.userLoggedIn()) {
			return;
		}

		const completeness = store.getters.bestFitCompleteness();
		if (completeness && completeness < 100) {
			return;
		}

		globals.eventBus.on('moduleReady', () => {
			this.onCalculationComplete();
		});
	}

	private onCalculationComplete(): void {
		if (this.studyId && typeof this.studyId === 'number') {
			store.mutations.setActiveStudyId(this.studyId);
			store.actions.openOverview();
			this.completed = true;
		}
	}
}
